import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Layout Components
import Navbar from './components/layout/Navbar';
import ScrollToTop from './components/utils/ScrollToTop';

// Page Components
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Certifications from './pages/Certifications/Certifications';
import Trainings from './pages/Trainings/Trainings';
import PastProjects from './pages/PastProjects/PastProjects';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/trainings" element={<Trainings />} />
            <Route path="/past-projects" element={<PastProjects />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;